import { format as dateFormat } from 'date-fns';

const isArray = (target: any): boolean => Object.prototype.toString.call(target) == '[object Array]';
const isString = (target: any): boolean => Object.prototype.toString.call(target) == '[object String]';
const isObject = (target: any): boolean => Object.prototype.toString.call(target) == '[object Object]';

export function format (date: Date | number | string, formatStr: string = 'YYYY-MM-DD'){
	return dateFormat(date, formatStr);
}

export function serialize (obj: any){
	let params: any = {};
	Object.entries(obj)
		.map((item: any) => {
			return !!(item[1] !== undefined && item[1] !== null && item[1] !== '')
				? { key: item[0], value: item[1] }
				: null;
		})
		.filter(item => !!item)
		.forEach((item: any) => {
			params[item.key] = item.value;
		});
	return params;
}

export function flatten (arr: Array<any>): Array<any>{
	return arr.reduce((flat, toFlatten) => {
		return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
	}, []);
}

export function parseDict (dict: { [key: string]: Array<any> }, index: number = 0){
	if (index < 0) {
		return Object.entries(dict).map((item: Array<any>) => {
			return { label: item[1][0], value: item[1][Math.abs(index)] };
		});
	}
	return JSON.parse(
		'{' +
			Object.entries(dict)
				.map((item: Array<any>) => {
					const key = item[0];
					const value = item[1][index];
					return '"' + key + '": ' + (isString(value) ? '"' : '') + value + (isString(value) ? '"' : '');
				})
				.join(',') +
			'}',
	);
}
